import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { LOCATION_CHANGED } from 'redux-little-router';

import { Action } from '../actions';
import { UrlHelpers } from '../service/UrlHelpers';
import { State } from '../typings/state';

import { PUBLIC_DOMAIN_PAGES, RoutesPath } from './index';

export const routesMiddleware: Middleware<{}, State, Dispatch<Action>> = (
    store: MiddlewareAPI<Dispatch<Action>>
): ((next: Dispatch<Action>) => (action: Action) => Action) => (
    next: Dispatch<Action>
): ((action: Action) => Action) => (action: Action): Action => {
    switch (action.type) {
        case LOCATION_CHANGED: {
            const {
                commonData: { publicDomain, login }
            } = store.getState();
            const { pathname, search, route, result } = action.payload;

            if (publicDomain && !PUBLIC_DOMAIN_PAGES.includes(route) && !login) {
                UrlHelpers.openUrl(`${pathname}${search}`);
            }

            if (result) {
                setCurrentDocumentTitle(route, result as { title: string });
            }
            break;
        }
        default:
            break;
    }

    return next(action);
};

// Статические не динамические роуты.
function setCurrentDocumentTitle(currentRoute: string, result: { title: string }): void {
    switch (currentRoute) {
        case RoutesPath.log:
        case RoutesPath.recommendationsPage:
        case RoutesPath.recommendationsItems:
        case RoutesPath.welcome:
        case RoutesPath.mobileAppsList:
        case RoutesPath.mobileAppsEdit:
        case RoutesPath.mobileAppsCreate:
        case RoutesPath.deals:
        case RoutesPath.offlineReports:
        case RoutesPath.domainsReports:
        case RoutesPath.freelancersEdit:
        case RoutesPath.bannersEdit:
        case RoutesPath.internalBannersEdit:
        case RoutesPath.groupsEdit:
        case RoutesPath.tools:
        case RoutesPath.toolsExcel:
        case RoutesPath.minusPhrasesLibrary:
        case RoutesPath.freelancersList:
        case RoutesPath.freelancerCard:
        case RoutesPath.freelancerCustomers:
        case RoutesPath.products:
        case RoutesPath.marketers:
        case RoutesPath.marketerCard:
        case RoutesPath.campaignsEdit:
        case RoutesPath.userSettings:
        case RoutesPath.pricePackagesList:
        case RoutesPath.pricePackagesEdit:
        case RoutesPath.videoCreatorMyVideo:
        case RoutesPath.videoCreatorTemplatesList:
        case RoutesPath.videoCreatorEdit:
            document.title = result.title;
            break;
        default:
            break;
    }
}
